var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#010412;}\n\t.st1{fill:#1B7FF4;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 7.4,
    className: "st0",
    width: 46.1,
    height: 46.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M44.9,1.3H19.1C8,1.3,1.3,7.9,1.3,19.1v25.7c0,11.2,6.7,17.9,17.8,17.9h25.7c11.2,0,17.8-6.7,17.8-17.8V19.1 C62.7,7.9,56.1,1.3,44.9,1.3z M21.2,22.7l9.2-9.2c0.2-0.2,0.5-0.4,0.7-0.5c0.6-0.2,1.2-0.2,1.8,0c0.3,0.1,0.5,0.3,0.7,0.5l9.2,9.2 c0.9,0.9,0.9,2.4,0,3.3c-0.5,0.5-1,0.7-1.6,0.7c-0.6,0-1.2-0.2-1.6-0.7l-5.3-5.3v19c0,1.3-1,2.3-2.3,2.3c-1.3,0-2.3-1-2.3-2.3v-19 L24.4,26c-0.9,0.9-2.4,0.9-3.3,0C20.2,25.1,20.3,23.6,21.2,22.7z M51.2,48C45,50.1,38.5,51.1,32,51.1s-13-1-19.2-3.1 c-1.2-0.4-1.8-1.7-1.4-2.9s1.7-1.9,2.9-1.4c11.4,3.8,24,3.8,35.4,0c1.2-0.4,2.5,0.2,2.9,1.4C53,46.3,52.4,47.6,51.2,48z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendSquare);
export default __webpack_public_path__ + "static/media/send-square.6ef5665985c178faf1ffb6ee7ea5bbcc.svg";
export { ForwardRef as ReactComponent };